import React,{useState} from "react";
import Img from "../../Products/Image";
import SaleOff from "../../Products/SaleOff";
import { RoundFloor } from '../../../utils/format'
import { navigate } from 'gatsby';
import { actionCart } from '../../../service/cartService';
import { toast } from "react-toastify";
import { checkWWishlist, deleteWishlist, createWishlist, addProductToWishlist } from '../../../service/wishlistService';

import "react-multi-carousel/lib/styles.css";

import { PropertiesHotdeal, PropertiesProduct } from "../../Products/description";
import { isAuth } from "../../../helpers/general";
import { pushtracking } from "../../../service/trackingService";
import { useLocation } from "@reach/router";
const ItemHotDeal = ({ item, index }) => {
    const percen = +item?.price['discount'] / item.price['raw'] * 100;
    const location = useLocation();
    const handleAddToCart = (item, uri) => {
        if (isAuth() === false) {
            //toast.error('Bạn cần đăng nhập trước khi mua hàng.');
            setTimeout(() => { window.location.href = '/dang-nhap.html' }, 3500);
        } else {
            if (item.sku.includes('C') === true || +item.typePromotion === 3) {
                window.localStorage.setItem('typepage', 'product');
                if(uri !== '/undefined'){
                    // navigate(uri);
                    window.location.href = uri;
                }
            } else {
                let params = {
                    items: [{
                        product: item.sku,
                        type: 'item',
                        action: 'add',
                        quantity: 1,
                        promo_code: item.promoCode?? "",
                        combo_code: item.combCode ?? '',
                        uudai: item.uuDai,
                        user_referral:  window.localStorage.getItem('userReferral'),
                        id_share:   window.localStorage.getItem('idShare')
                    }]
                }
                try {
                    actionCart(params, window.localStorage.getItem('key')).then((response) => {
                        if(+response.status === 200 && response.message?.length > 0){
                        localStorage.removeItem("itemsCart");
                        localStorage.setItem('itemsCart', JSON.stringify(response['message']));
                        window.localStorage.setItem('reloadCart', true);
                        toast.success('Thêm vào giỏ hàng thành công.');

                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({ ecommerce: null });
                        window.dataLayer.push({
                                'event': 'add_to_cart',
                                'ecommerce': {
                                'currency': "VND",
                                'value': +item.price?.import,
                                    'items': [
                                    {
                                        item_id: item.sku,
                                        item_name: item.name,
                                        price: +item.price?.import
                                    }
                                    ]
                                }
                            });
                            try{
                                pushtracking(window.localStorage.getItem('sessionId')??null,
                                window.localStorage.getItem('_id')??null,
                                window.localStorage.getItem('phone')??null ,
                                location.pathname, "Thêm sản phẩm vào giỏ hàng", 0,0,'index','inWeb',[item.sku],'Website PC').then((response)=>{
                                    console.log('send tracking');
                                });
                            }catch(e){console.log(e)}
                        }
                    });
                } catch (err) {
                    console.log(err);
                }
            }
        }
    }
    const handleRedirect = (uri) => {
        window.localStorage.setItem('typepage', 'product');
        if(uri !== '/undefined'){
            navigate(uri);
        }
    }
    const [wishlist, setWishlist] = useState(false);
    const handleWishlist = (sku, isFavorite) => {
        if (window.localStorage.getItem('key')) {
            setWishlist(!wishlist);
            checkWWishlist(window.localStorage.getItem('_id'), window.localStorage.getItem('_id'), sku).then((response) => {
                console.log(response);
            })

            if (isFavorite) {
                deleteWishlist(window.localStorage.getItem('_id'), window.localStorage.getItem('_id'), sku).then((response) => {
                    console.log(response);
                })
            } else {
                let param = {
                    "code": window.localStorage.getItem('_id'),
                    "user_id": window.localStorage.getItem('_id'),
                    "name": "danh-sach-yeu-thich",
                    "source": "cusapp",
                    "type": "",
                };
                createWishlist(param).then((response) => {
                    if (+response.status === 200) {
                        let data = {
                            "wishlist_id": window.localStorage.getItem('_id'),
                            "user_id": window.localStorage.getItem('_id'),
                            "product_id": sku,
                        };
                        addProductToWishlist(data).then((response) => {
                            console.log(response);
                        })
                    }
                })
            }
        }
    }
    return (
        <div key={index} className="item product-layout product-grid">
            <div className="product-thumb transition product-item-container hotdeal-boder-right">
                <div className="left-block position-relative">
                    <div className="product-image-container  second_img">
                        <div className="image">
                            <a onClick={() => handleRedirect('/' + item.linksp?.replace('/', ''))} href={'/' + item.linksp?.replace('/', '')}>
                                <Img key={item.thumbnail + index} imgTitle={item.name} url={item.thumbnail} className="w-100" style="" />
                                {/* <Img key={item.thumbnail} imgTitle={item.name} url={item.thumbnail} className="img-2 img-responsive" style="" /> */}
                            </a>
                        </div>

                        <div className="button-group cartinfo--right">
                            <button className="btn-button addToCart" title="Add to Cart" type="button" onClick={() => handleAddToCart(item, '/' + item.linksp?.replace('/', ''))}><i className="fa fa-shopping-cart"></i> <span>Add to Cart</span></button>
                            <button className="btn-button wishlist" type="button" title="Add to Wish List" ><img onClick={() => handleWishlist(item.sku, item.isFavorite)} className="img-like" src={wishlist || item.isFavorite ? ("/../images/web_app/ic_like_active.svg") : ("https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_like.png")} alt="icon"/><span>Add to Wish List</span></button>
                            <button className="btn-button compare" type="button" title="Chi tiết sản phẩm"
                                onClick={() => handleRedirect('/' + item.linksp?.replace('/', ''))}
                            ><i className="fa fa-eye"></i><span>Chi tiết sản phẩm</span></button>
                        </div>
                    </div>
                    {
                        +item.price['discount'] !== +item.price['raw'] ? (<SaleOff key={index}
                            percen={RoundFloor(100 - percen)} />) : (null)
                    }
{
                            item.labelPromo ? (
                                <img src={item.labelPromo['imageWeb']['default']['url']} alt="icon-chinh-hang"
                                style={item.labelPromo['position']['bottom']?({
                                    width:+item.labelPromo['imageWeb']['default']['sizeImage']['width'],
                                    height:+item.labelPromo['imageWeb']['default']['sizeImage']['height'],
                                    left:+ item.labelPromo['position']['left'],
                                    bottom:+ (+item.labelPromo['position']['bottom']+31),
                                    zIndex:1, position:"absolute"
                            }):({
                                width:+item.labelPromo['imageWeb']['default']['sizeImage']['width'],
                                height:+item.labelPromo['imageWeb']['default']['sizeImage']['height'],
                                left:+ item.labelPromo['position']['left'],
                                top:+ item.labelPromo['position']['top'],
                                zIndex:1, position:"absolute"
                        })
                                    
                                }/>
                            ):(null)
                        }
                </div>
                <PropertiesHotdeal key={index} item={item} tag="Hotdeal" />
            </div>
        </div>
    )
}

const Item = ({ item, index }) => {
    if(item.typePromotion &&  +item.typePromotion  !== 1 && item.parent){
        item.linksp = item.parent.linksp;
    }
    const percen = +item?.price['discount'] / item.price['raw'] * 100;
    const location = useLocation();
    const handleAddToCart = (item, uri) => {
        if (isAuth() === false) {
            //toast.error('Bạn cần đăng nhập trước khi mua hàng.');
            setTimeout(() => { window.location.href = '/dang-nhap.html' }, 3500);
        } else {
            if (item.sku.includes('C') === true || +item.typePromotion === 3) {
                window.localStorage.setItem('typepage', 'product');
                // navigate(uri);
                window.location.href = uri;
            } else {
                let params = {
                    items: [{
                        product: item.sku,
                        type: 'item',
                        action: 'add',
                        quantity: 1,
                        promo_code: item.promoCode?? "",
                        combo_code: item.combCode ?? '',
                        uudai: item.uuDai,
                        user_referral:  window.localStorage.getItem('userReferral'),
                        id_share:   window.localStorage.getItem('idShare')
                    }]
                }
                try {
                    actionCart(params, window.localStorage.getItem('key')).then((response) => {
                        if(+response.status === 200 && response.message?.length > 0){
                        localStorage.removeItem("itemsCart");
                        localStorage.setItem('itemsCart', JSON.stringify(response['message']));
                        window.localStorage.setItem('reloadCart', true);
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({ ecommerce: null });
                        window.dataLayer.push({
                                'event': 'add_to_cart',
                                'ecommerce': {
                                'currency': "VND",
                                'value': +item.price?.import,
                                    'items': [
                                    {
                                        item_id: item.sku,
                                        item_name: item.name,
                                        price: +item.price?.import
                                    }
                                    ]
                                }
                            });
                        try{
                                pushtracking(window.localStorage.getItem('sessionId')??null,
                                window.localStorage.getItem('_id')??null,
                                window.localStorage.getItem('phone')??null ,
                                location.pathname, "Thêm sản phẩm vào giỏ hàng", 0,0,'index','inWeb',[item.sku],'Website PC').then((response)=>{
                                    console.log('send tracking');
                                });
                            }catch(e){console.log(e)}
                        toast.success('Thêm vào giỏ hàng thành công.');
                        }
                    });
                } catch (err) {
                    console.log(err);
                }
            }
        }
    }
    const handleRedirect = (uri) => {
        window.localStorage.setItem('typepage', 'product');
        if(uri !== '/undefined'){
            navigate(uri);
        }
    }

    const [wishlist, setWishlist] = useState(false);
    const handleWishlist = (sku, isFavorite) => {
        if (window.localStorage.getItem('key')) {
            setWishlist(!wishlist);
            checkWWishlist(window.localStorage.getItem('_id'), window.localStorage.getItem('_id'), sku).then((response) => {
                console.log(response);
            })

            if (isFavorite) {
                deleteWishlist(window.localStorage.getItem('_id'), window.localStorage.getItem('_id'), sku).then((response) => {
                    console.log(response);
                })
            } else {
                let param = {
                    "code": window.localStorage.getItem('_id'),
                    "user_id": window.localStorage.getItem('_id'),
                    "name": "danh-sach-yeu-thich",
                    "source": "cusapp",
                    "type": "",
                };
                createWishlist(param).then((response) => {
                    if (+response.status === 200) {
                        let data = {
                            "wishlist_id": window.localStorage.getItem('_id'),
                            "user_id": window.localStorage.getItem('_id'),
                            "product_id": sku,
                        };
                        addProductToWishlist(data).then((response) => {
                            console.log(response);
                        })
                    }
                })
            }
        }
    }

    return (
        <div key={index} className="item product-layout product-grid">
            <div className="product-thumb transition product-item-container gift-boder-right">
                <div className="left-block">
                    <div className="banners product-image-container  second_img position-relative">
                        <div className="image img-gift">
                            <a href={item.linksp ? ('/' + item.linksp?.replace('/', '')) : (null)}>
                                {
                                    item.is_thumbnail_gifts ? (
                                        <>
                                            <Img key={item.thumbnail + index} imgTitle={item.name} url={item.thumbnail.replace('/origin', '/thumb')}/>
                                            {/* <div className="img-gift-nav">
                                                <div className="special-text">
                                                    <Img key={item.thumbnail} imgTitle={item.name} url={item.thumbnail.replace('/origin', '/thumb')} className="img-gift2 lazyloaded" style="" />
                                                    <span className="special-text__tooltip">Tặng</span>
                                                </div>
                                            </div> */}
                                        </>

                                    ) : (
                                        <>
                                            <Img key={item.thumbnail + index} imgTitle={item.name} url={item.thumbnail.replace('/origin', '/thumb')} className="" style="" />
                                            {/* <Img key={item.thumbnail} imgTitle={item.name} url={item.thumbnail.replace('/origin', '/thumb')} className="img-2 img-responsive" style="" /> */}
                                        </>
                                    )
                                }
                            </a>
                        </div>
                        <div className="button-group cartinfo--right">
                            <button className="btn-button addToCart" title="Add to Cart" type="button" ><i className="fa fa-shopping-cart" onClick={() => handleAddToCart(item, '/' + item.linksp?.replace('/', ''))}></i> <span>Add to Cart</span></button>
                            <button className="btn-button wishlist" type="button" title="Add to Wish List" ><img onClick={() => handleWishlist(item.sku, item.isFavorite)} className="img-like" src={wishlist || item.isFavorite ? ("/../images/web_app/ic_like_active.svg") : ("https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_like.png")} alt="icon"/><span>Add to Wish List</span></button>
                            <button className="btn-button compare" type="button" title="Chi tiết sản phẩm" onClick={() => handleRedirect('/' + item.linksp?.replace('/', ''))}>
                                <i className="fa fa-eye" id={item.linksp}></i><span>Chi tiết sản phẩm</span></button>
                        </div>

                        {
                        item.labelPromo ? (
                            <img src={item.labelPromo['imageWeb']['default']['url']} alt="icon-chinh-hang" className="position-absolute"
                            style={item.labelPromo['position']['bottom']?({
                                width:+item.labelPromo['imageWeb']['default']['sizeImage']['width'],
                                height:+item.labelPromo['imageWeb']['default']['sizeImage']['height'],
                                left:+ item.labelPromo['position']['left'],
                                bottom:+ (+item.labelPromo['position']['bottom']),
                                zIndex:1, position:"absolute"
                        }):({
                            width:+item.labelPromo['imageWeb']['default']['sizeImage']['width'],
                            height:+item.labelPromo['imageWeb']['default']['sizeImage']['height'],
                            left:+ item.labelPromo['position']['left'],
                            top:+ item.labelPromo['position']['top'],
                            zIndex:1, position:"absolute"
                    })
                                
                            }/>
                        ):(null)
                    }
                    </div>
                    {
                        +item.price['discount'] !== +item.price['raw'] ? (<SaleOff key={index}
                            percen={RoundFloor(100 - percen)} />) : (null)
                    }
                </div>
                <PropertiesProduct key={index} item={item} tag='' />
            </div>
        </div>
    )
}

const Upsell = ({ item, index }) => {
    if(item.typePromotion &&  +item.typePromotion  !== 1 && item.parent){
        item.linksp = item.parent.linksp;
    }
    const percen = +item?.price['discount'] / item.price['raw'] * 100;
    const location = useLocation()
    const handleAddToCart = (item,uri) => {
        if (isAuth() === false) {
            //toast.error('Bạn cần đăng nhập trước khi mua hàng.');
            setTimeout(() => { window.location.href = '/dang-nhap.html' }, 3500);
        } else {
            if (item.sku.includes('C') === true || +item.typePromotion === 3) {
                window.localStorage.setItem('typepage', 'product');
                // navigate(uri);
                window.location.href = uri;
            } else {
                let params = {
                    items: [{
                        product: item.sku,
                        type: 'item',
                        action: 'add',
                        quantity: 1,
                        promo_code: item.promoCode?? "",
                        combo_code: item.combCode ?? '',
                        uudai: item.uuDai,
                        user_referral:  window.localStorage.getItem('userReferral'),
                        id_share:   window.localStorage.getItem('idShare')
                    }]
                }
                try {
                    actionCart(params, window.localStorage.getItem('key')).then((response) => {
                        if(+response.status === 200 && response.message?.length > 0){
                        localStorage.removeItem("itemsCart");
                        localStorage.setItem('itemsCart', JSON.stringify(response['message']));
                        window.localStorage.setItem('reloadCart', true);
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({ ecommerce: null });
                        window.dataLayer.push({
                                'event': 'add_to_cart',
                                'ecommerce': {
                                'currency': "VND",
                                'value': +item.price?.import,
                                    'items': [
                                    {
                                        item_id: item.sku,
                                        item_name: item.name,
                                        price: +item.price?.import
                                    }
                                    ]
                                }
                            });
                        try{
                                pushtracking(window.localStorage.getItem('sessionId')??null,
                                window.localStorage.getItem('_id')??null,
                                window.localStorage.getItem('phone')??null ,
                                location.pathname, "Thêm sản phẩm vào giỏ hàng", 0,0,'index','inWeb',[item.sku],'Website PC').then((response)=>{
                                    console.log('send tracking');
                                });
                            }catch(e){console.log(e)}
                        toast.success('Thêm vào giỏ hàng thành công.');
                        }
                    });
                } catch (err) {
                    console.log(err);
                }
            }
        }
    }
    const handleRedirect = (uri) => {
        window.localStorage.setItem('typepage', 'product');
        if(uri !== '/undefined'){
            navigate(uri);
        }
    }
    const [wishlist, setWishlist] = useState(false);
    const handleWishlist = (sku, isFavorite) => {
        if (window.localStorage.getItem('key')) {
            setWishlist(!wishlist);
            checkWWishlist(window.localStorage.getItem('_id'), window.localStorage.getItem('_id'), sku).then((response) => {
                console.log(response);
            })

            if (isFavorite) {
                deleteWishlist(window.localStorage.getItem('_id'), window.localStorage.getItem('_id'), sku).then((response) => {
                    console.log(response);
                })
            } else {
                let param = {
                    "code": window.localStorage.getItem('_id'),
                    "user_id": window.localStorage.getItem('_id'),
                    "name": "danh-sach-yeu-thich",
                    "source": "cusapp",
                    "type": "",
                };
                createWishlist(param).then((response) => {
                    if (+response.status === 200) {
                        let data = {
                            "wishlist_id": window.localStorage.getItem('_id'),
                            "user_id": window.localStorage.getItem('_id'),
                            "product_id": sku,
                        };
                        addProductToWishlist(data).then((response) => {
                            console.log(response);
                        })
                    }
                })
            }
        }
    }
    return (
        <div key={index} className="item product-layout product-grid">
            <div className="product-thumb transition product-item-container gift-boder-right">
                <div className="left-block">
                    <div className="banners product-image-container  second_img ">
                        <div className="image img-gift">
                            <a href={item.linksp ? ('/' + item.linksp?.replace('/', '')):(null)}>
                                {
                                    item.is_thumbnail_gifts ? (
                                        <>
                                            <Img key={item.thumbnail + index} imgTitle={item.name} url={item.thumbnail.replace('/origin', '/thumb')}/>
                                            {/* <div className="img-gift-nav">
                                                <div className="special-text">
                                                    <Img key={item.thumbnail} imgTitle={item.name} url={item.thumbnail.replace('/origin', '/thumb')} className="img-gift2 lazyloaded" style="" />
                                                    <span className="special-text__tooltip">Tặng</span>
                                                </div>
                                            </div> */}
                                        </>

                                    ) : (
                                        <>
                                            <Img key={item.thumbnail + index} imgTitle={item.name} url={item.thumbnail.replace('/origin', '/thumb')} className="" style="" />
                                            {/* <Img key={item.thumbnail} imgTitle={item.name} url={item.thumbnail.replace('/origin', '/thumb')} className="img-2 img-responsive" style="" /> */}
                                        </>
                                    )
                                }
                            </a>
                        </div>
                        <div className="button-group cartinfo--right">
                            <button className="btn-button addToCart" title="Add to Cart" type="button" ><i className="fa fa-shopping-cart" onClick={() => handleAddToCart(item, '/' + item.linksp?.replace('/', ''))}></i> <span>Add to Cart</span></button>
                            <button className="btn-button wishlist" type="button" title="Add to Wish List" ><img onClick={() => handleWishlist(item.sku, item.isFavorite)} className="img-like" src={wishlist || item.isFavorite ? ("/../images/web_app/ic_like_active.svg") : ("https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_like.png")} alt="icon"/><span>Add to Wish List</span></button>
                            <button className="btn-button compare" type="button" title="Chi tiết sản phẩm" onClick={() => handleRedirect('/' + item.linksp?.replace('/', ''))}>
                                <i className="fa fa-eye" id={item.linksp}></i><span>Chi tiết sản phẩm</span></button>
                        </div>

                        {
                        item.labelPromo ? (
                            <img src={item.labelPromo['imageWeb']['default']['url']} alt="icon-chinh-hang" className="position-absolute"
                            style={item.labelPromo['position']['bottom']?({
                                width:+item.labelPromo['imageWeb']['default']['sizeImage']['width'],
                                height:+item.labelPromo['imageWeb']['default']['sizeImage']['height'],
                                left:+ item.labelPromo['position']['left'],
                                bottom:+ (+item.labelPromo['position']['bottom']),
                                zIndex:1, position:"absolute"
                        }):({
                            width:+item.labelPromo['imageWeb']['default']['sizeImage']['width'],
                            height:+item.labelPromo['imageWeb']['default']['sizeImage']['height'],
                            left:+ item.labelPromo['position']['left'],
                            top:+ item.labelPromo['position']['top'],
                            zIndex:1, position:"absolute"
                    })
                                
                            }/>
                        ):(null)
                    }
                    </div>
                    {
                        +item.price['discount'] !== +item.price['raw'] ? (<SaleOff key={index}
                            percen={RoundFloor(100 - percen)} />) : (null)
                    }
                </div>
                <PropertiesProduct key={index} item={item} tag='Giảm giá' />
            </div>
        </div>
    )
}
const ItemAddGift = ({ item, index }) => {
    if(item.typePromotion &&  +item.typePromotion  !== 1 && item.parent){
        item.linksp = item.parent.linksp;
    }
    const percen = +item?.price['discount'] / item.price['raw'] * 100;
    const location = useLocation();
    const handleAddToCart = (item, uri) => {
        if (isAuth() === false) {
            //toast.error('Bạn cần đăng nhập trước khi mua hàng.');
            setTimeout(() => { window.location.href = '/dang-nhap.html' }, 3500);
        } else {
            if (item.sku.includes('C') === true || +item.typePromotion === 3) {
                window.localStorage.setItem('typepage', 'product');
                if(uri !== '/undefined'){
                    // navigate(uri);
                    window.location.href = uri;
                }
            } else {
                let params = {
                    items: [{
                        product: item.sku,
                        type: 'item',
                        action: 'add',
                        quantity: 1,
                        promo_code: item.promoCode?? "",
                        combo_code: item.combCode ?? '',
                        uudai: item.uuDai,
                        user_referral:  window.localStorage.getItem('userReferral'),
                        id_share:   window.localStorage.getItem('idShare')
                    }]
                }
                try {
                    actionCart(params, window.localStorage.getItem('key')).then((response) => {
                        if(+response.status === 200 && response.message?.length > 0){
                        localStorage.removeItem("itemsCart");
                        localStorage.setItem('itemsCart', JSON.stringify(response['message']));
                        window.localStorage.setItem('reloadCart', true);
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({ ecommerce: null });
                        window.dataLayer.push({
                                'event': 'add_to_cart',
                                'ecommerce': {
                                'currency': "VND",
                                'value': +item.price?.import,
                                    'items': [
                                    {
                                        item_id: item.sku,
                                        item_name: item.name,
                                        price: +item.price?.import
                                    }
                                    ]
                                }
                            });
                        try{
                                pushtracking(window.localStorage.getItem('sessionId')??null,
                                window.localStorage.getItem('_id')??null,
                                window.localStorage.getItem('phone')??null ,
                                location.pathname, "Thêm sản phẩm vào giỏ hàng", 0,0,'index','inWeb',[item.sku],'Website PC').then((response)=>{
                                    console.log('send tracking');
                                });
                            }catch(e){console.log(e)}
                        toast.success('Thêm vào giỏ hàng thành công.');
                        }
                    });
                } catch (err) {
                    console.log(err);
                }
            }
        }
    }
    const handleRedirect = (uri) => {
        window.localStorage.setItem('typepage', 'product');
        if(uri !== '/undefined'){
            navigate(uri);
        }
    }
    const [wishlist, setWishlist] = useState(false);
    const handleWishlist = (sku, isFavorite) => {
        if (window.localStorage.getItem('key')) {
            setWishlist(!wishlist);
            checkWWishlist(window.localStorage.getItem('_id'), window.localStorage.getItem('_id'), sku).then((response) => {
                console.log(response);
            })

            if (isFavorite) {
                deleteWishlist(window.localStorage.getItem('_id'), window.localStorage.getItem('_id'), sku).then((response) => {
                    console.log(response);
                })
            } else {
                let param = {
                    "code": window.localStorage.getItem('_id'),
                    "user_id": window.localStorage.getItem('_id'),
                    "name": "danh-sach-yeu-thich",
                    "source": "cusapp",
                    "type": "",
                };
                createWishlist(param).then((response) => {
                    if (+response.status === 200) {
                        let data = {
                            "wishlist_id": window.localStorage.getItem('_id'),
                            "user_id": window.localStorage.getItem('_id'),
                            "product_id": sku,
                        };
                        addProductToWishlist(data).then((response) => {
                            console.log(response);
                        })
                    }
                })
            }
        }
    }
    return (
        <div key={index} className="item product-layout product-grid">
            <div className="product-thumb transition product-item-container gift-boder-right">
                <div className="left-block">
                    <div className="banners product-image-container  second_img ">
                        <div className="image img-gift">
                            <a href={item.linksp ? ('/' + item.linksp?.replace('/', '')):(null)}>
                                {
                                    item.is_thumbnail_gifts ? (
                                        <>
                                            <Img key={item.thumbnail + index} imgTitle={item.name} url={item.thumbnail.replace('/origin', '/thumb')} />
                                            {/* <Img key={item.thumbnail+index} imgTitle={item.name} url={item.thumbnail} className="img-gift1 lazyloaded" style=""/>  */}
                                            {/* <div className="img-gift-nav"> */}
                                                {/* <div className="special-text">
                                    <Carousel key="gift"
                                        responsive={ResponsiveSliderTop}
                                        showDots={true}
                                        fade={true}
                                        // autoPlay={true}
                                        // autoPlaySpeed={2000}
                                        >
                                            {
                                                item.thumbnail_gifts.map((gift_img, i)=>{
                                                    return <div key={i}> 
                                                            <Img key={gift_img} imgTitle={item.name} url={gift_img.replace('/origin','/thumb')} className="img-gift2 lazyloaded" style=""/>
                                                        </div>
                                                })
                                            }
                                           </Carousel>
                                           <span className="special-text__tooltip">Tặng</span>
                                           </div> */}
                                                {/* <div className="special-text">
                                                    <Img key={item.thumbnail_gifts[0]} imgTitle={item.name} url={item.thumbnail_gifts[0].replace('/origin', '/thumb')} className="img-gift2 lazyloaded" style="" />
                                                    <span className="special-text__tooltip">Tặng</span>
                                                </div>
                                            </div> */}
                                        </>

                                    ) : (
                                        <>
                                            <Img key={item.thumbnail + index} imgTitle={item.name} url={item.thumbnail.replace('/origin', '/thumb')} className="" style="" />
                                            {/* <Img key={item.thumbnail} imgTitle={item.name} url={item.thumbnail.replace('/origin', '/thumb')} className="img-2 img-responsive" style="" /> */}
                                        </>
                                    )
                                }
                            </a>
                        </div>
                        <div className="button-group cartinfo--right">
                            <button className="btn-button addToCart" title="Add to Cart" type="button" ><i className="fa fa-shopping-cart" onClick={() => handleAddToCart(item, '/' + item.linksp?.replace('/', ''))}></i> <span>Add to Cart</span></button>
                            <button className="btn-button wishlist" type="button" title="Add to Wish List" ><img onClick={() => handleWishlist(item.sku, item.isFavorite)} className="img-like" src={wishlist || item.isFavorite ? ("/../images/web_app/ic_like_active.svg") : ("https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_like.png")} alt="icon"/><span>Add to Wish List</span></button>
                            <button className="btn-button compare" type="button" title="Chi tiết sản phẩm" onClick={() => handleRedirect('/' + item.linksp?.replace('/', ''))}>
                                <i className="fa fa-eye" id={item.linksp}></i><span>Chi tiết sản phẩm</span></button>
                        </div>
                        {
                        item.labelPromo ? (
                            <img src={item.labelPromo['imageWeb']['default']['url']} alt="icon-chinh-hang" className="position-absolute"
                            style={item.labelPromo['position']['bottom']?({
                                width:+item.labelPromo['imageWeb']['default']['sizeImage']['width'],
                                height:+item.labelPromo['imageWeb']['default']['sizeImage']['height'],
                                left:+ item.labelPromo['position']['left'],
                                bottom:+ (+item.labelPromo['position']['bottom']),
                                zIndex:1, position:"absolute"
                        }):({
                            width:+item.labelPromo['imageWeb']['default']['sizeImage']['width'],
                            height:+item.labelPromo['imageWeb']['default']['sizeImage']['height'],
                            left:+ item.labelPromo['position']['left'],
                            top:+ item.labelPromo['position']['top'],
                            zIndex:1, position:"absolute"
                    })
                                
                            }/>
                        ):(null)
                    }
                    </div>
                    {
                        +item.price['discount'] !== +item.price['raw'] ? (<SaleOff key={index}
                            percen={RoundFloor(100 - percen)} />) : (null)
                    }
                </div>
                <PropertiesProduct key={index} item={item} tag='Mua là có Quà' />
            </div>
        </div>
    )
}

const ItemDefault = ({ item, index, isShowAddToCart, isShowCategoryName }) => {
    if(item.typePromotion &&  +item.typePromotion  !== 1 && item.parent){
        item.linksp = item.parent.linksp;
    }
    const location = useLocation();
    const handleAddToCart = (item, uri) => {
        if (isAuth() === false) {
            //toast.error('Bạn cần đăng nhập trước khi mua hàng.');
            setTimeout(() => { window.location.href = '/dang-nhap.html' }, 3500);
        } else {
            if (item.sku.includes('C') === true || +item.typePromotion === 3) {
                window.localStorage.setItem('typepage', 'product');
                if(uri !== '/undefined'){
                    // navigate(uri);
                    window.location.href = uri;
                }
            } else {
                let params = {
                    items: [{
                        product: item.sku,
                        type: 'item',
                        action: 'add',
                        quantity: 1,
                        promo_code: item.promoCode?? "",
                        combo_code: item.combCode ?? '',
                        uudai: item.uuDai,
                        user_referral:  window.localStorage.getItem('userReferral'),
                        id_share:   window.localStorage.getItem('idShare')
                    }]
                }
                try {
                    actionCart(params, window.localStorage.getItem('key')).then((response) => {
                        if(+response.status === 200 && response.message?.length > 0){
                        localStorage.removeItem("itemsCart");
                        localStorage.setItem('itemsCart', JSON.stringify(response['message']));
                        window.localStorage.setItem('reloadCart', true);
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({ ecommerce: null });
                        window.dataLayer.push({
                                'event': 'add_to_cart',
                                'ecommerce': {
                                'currency': "VND",
                                'value': +item.price?.import,
                                    'items': [
                                    {
                                        item_id: item.sku,
                                        item_name: item.name,
                                        price: +item.price?.import
                                    }
                                    ]
                                }
                            });
                        try{
                                pushtracking(window.localStorage.getItem('sessionId')??null,
                                window.localStorage.getItem('_id')??null,
                                window.localStorage.getItem('phone')??null ,
                                location.pathname, "Thêm sản phẩm vào giỏ hàng", 0,0,'index','inWeb',[item.sku],'Website PC').then((response)=>{
                                    console.log('send tracking');
                                });
                            }catch(e){console.log(e)}
                        toast.success('Thêm vào giỏ hàng thành công.');
                        }
                    });
                } catch (err) {
                    console.log(err);
                }
            }
        }
    }
    const handleRedirect = (uri) => {
        window.localStorage.setItem('typepage', 'product');
        if(uri !== '/undefined'){
            navigate(uri);
        }
    }
    const [wishlist, setWishlist] = useState(false);
    const handleWishlist = (sku, isFavorite) => {
        if (window.localStorage.getItem('key')) {
            setWishlist(!wishlist);
            checkWWishlist(window.localStorage.getItem('_id'), window.localStorage.getItem('_id'), sku).then((response) => {
                console.log(response);
            })

            if (isFavorite) {
                deleteWishlist(window.localStorage.getItem('_id'), window.localStorage.getItem('_id'), sku).then((response) => {
                    console.log(response);
                })
            } else {
                let param = {
                    "code": window.localStorage.getItem('_id'),
                    "user_id": window.localStorage.getItem('_id'),
                    "name": "danh-sach-yeu-thich",
                    "source": "cusapp",
                    "type": "",
                };
                createWishlist(param).then((response) => {
                    if (+response.status === 200) {
                        let data = {
                            "wishlist_id": window.localStorage.getItem('_id'),
                            "user_id": window.localStorage.getItem('_id'),
                            "product_id": sku,
                        };
                        addProductToWishlist(data).then((response) => {
                            console.log(response);
                        })
                    }
                })
            }
        }
    }
    return (
        <div key={index} className="ltabs-item " style={{ opacity: 1 }}>
            <div className="item-inner product-layout transition product-grid">
                <div className="product-item-container myproduct product-thumb">
                    <div className="banners left-block">
                        <div className="product-image-container  second_img">
                            <div class="image">
                                <a href={item.linksp ? ('/' + item.linksp?.replace('/', '')):(null)} >
                                    {/* <Img key={item.thumbnail + index} data-sizes="auto" imgTitle={item.name} url={item.thumbnail.replace('/origin', '/thumb')} className="lazyload" style="" /> */}
                                    <Img key={item.thumbnail + index} data-sizes="auto" imgTitle={item.name} url={item.thumbnail_mini} className="lazyload" style="" />
                                </a>
                            </div>
                        </div>
                        <div className="button-group cartinfo--right">
                            <button className="btn-button addToCart" title="Add to Cart" type="button" ><i className="fa fa-shopping-cart" onClick={() => handleAddToCart(item, '/' + item.linksp.replace('/', ''))}></i> <span>Add to Cart</span></button>
                            <button className="btn-button wishlist" type="button" title="Add to Wish List" ><img onClick={() => handleWishlist(item.sku, item.isFavorite)} className="img-like" src={wishlist || item.isFavorite ? ("/../images/web_app/ic_like_active.svg") : ("https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_like.png")} alt="icon"/><span>Add to Wish List</span></button>
                            <button className="btn-button compare" type="button" title="Chi tiết sản phẩm" id={item.linksp} onClick={() => handleRedirect('/' + item.linksp.replace('/', ''))} ><i className="fa fa-eye"></i><span>Chi tiết sản phẩm</span></button>
                        </div>
                        <div className="box-label">
                        </div>
                        {
                        item.labelPromo ? (
                            <img src={item.labelPromo['imageWeb']['default']['url']} alt="icon-chinh-hang" className="position-absolute"
                            style={item.labelPromo['position']['bottom']?({
                                width:+item.labelPromo['imageWeb']['default']['sizeImage']['width'],
                                height:+item.labelPromo['imageWeb']['default']['sizeImage']['height'],
                                left:+ item.labelPromo['position']['left'],
                                bottom:+ (+item.labelPromo['position']['bottom']),
                                zIndex:1, position:"absolute"
                        }):({
                            width:+item.labelPromo['imageWeb']['default']['sizeImage']['width'],
                            height:+item.labelPromo['imageWeb']['default']['sizeImage']['height'],
                            left:+ item.labelPromo['position']['left'],
                            top:+ item.labelPromo['position']['top'],
                            zIndex:1, position:"absolute"
                    })
                                
                            }/>
                        ):(null)
                    }
                    </div>
                    {
                        isShowCategoryName === true ? (
                            <div className="category-name">
                                {window.localStorage.getItem('nameCategory')}
                            </div>
                        ) : (null)
                    }
                    <PropertiesProduct key={index} item={item} />
                    {
                        isShowAddToCart === true ? (
                            <div className="row add-to-cart mgx-0 pdb-10"><div className="col-md-2 i-cart"><i className="fa fa-cart-plus" onClick={()=>handleAddToCart(item, '/'+item.linksp.replace('/',''))}></i></div> <span>Thêm vào giỏ</span></div>
                        ):(null)
                    }
                </div>
            </div>
        </div>
    )
}

const ItemLanding = ({ item, index }) => {
    if(item.typePromotion &&  +item.typePromotion  !== 1 && item.parent){
        item.linksp = item.parent.linksp;
    }
    const percen = +item?.price['discount'] / item.price['raw'] * 100;
    const location = useLocation();
    const handleAddToCart = (item, uri) => {
        if (isAuth() === false) {
            //toast.error('Bạn cần đăng nhập trước khi mua hàng.');
            setTimeout(() => { window.location.href = '/dang-nhap.html' }, 3500);
        } else {
            if (item.sku.includes('C') === true || +item.typePromotion === 3) {
                window.localStorage.setItem('typepage', 'product');
                if(uri !== '/undefined'){
                    // navigate(uri);
                    window.location.href = uri;
                }
            } else {
                let params = {
                    items: [{
                        product: item.sku,
                        type: 'item',
                        action: 'add',
                        quantity: 1,
                        promo_code: item.promoCode?? "",
                        combo_code: item.combCode ?? '',
                        uudai: item.uuDai,
                        user_referral:  window.localStorage.getItem('userReferral'),
                        id_share:   window.localStorage.getItem('idShare')
                    }]
                }
                try {
                    actionCart(params, window.localStorage.getItem('key')).then((response) => {
                        if(+response.status === 200 && response.message?.length > 0){
                        localStorage.removeItem("itemsCart");
                        localStorage.setItem('itemsCart', JSON.stringify(response['message']));
                        window.localStorage.setItem('reloadCart', true);
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({ ecommerce: null });
                        window.dataLayer.push({
                                'event': 'add_to_cart',
                                'ecommerce': {
                                'currency': "VND",
                                'value': +item.price?.import,
                                    'items': [
                                    {
                                        item_id: item.sku,
                                        item_name: item.name,
                                        price: +item.price?.import
                                    }
                                    ]
                                }
                            });
                        try{
                                pushtracking(window.localStorage.getItem('sessionId')??null,
                                window.localStorage.getItem('_id')??null,
                                window.localStorage.getItem('phone')??null ,
                                location.pathname, "Thêm sản phẩm vào giỏ hàng", 0,0,'index','inWeb',[item.sku],'Website PC').then((response)=>{
                                    console.log('send tracking');
                                });
                            }catch(e){console.log(e)}
                        toast.success('Thêm vào giỏ hàng thành công.');
                        }
                    });
                } catch (err) {
                    console.log(err);
                }
            }
        }
    }
    const handleRedirect = (uri) => {
        window.localStorage.setItem('typepage', 'product');
        if(uri !== '/undefined'){
            navigate(uri);
        }
    }
    const [wishlist, setWishlist] = useState(false);
    const handleWishlist = (sku, isFavorite) => {
        if (window.localStorage.getItem('key')) {
            setWishlist(!wishlist);
            checkWWishlist(window.localStorage.getItem('_id'), window.localStorage.getItem('_id'), sku).then((response) => {
                console.log(response);
            })

            if (isFavorite) {
                deleteWishlist(window.localStorage.getItem('_id'), window.localStorage.getItem('_id'), sku).then((response) => {
                    console.log(response);
                })
            } else {
                let param = {
                    "code": window.localStorage.getItem('_id'),
                    "user_id": window.localStorage.getItem('_id'),
                    "name": "danh-sach-yeu-thich",
                    "source": "cusapp",
                    "type": "",
                };
                createWishlist(param).then((response) => {
                    if (+response.status === 200) {
                        let data = {
                            "wishlist_id": window.localStorage.getItem('_id'),
                            "user_id": window.localStorage.getItem('_id'),
                            "product_id": sku,
                        };
                        addProductToWishlist(data).then((response) => {
                            console.log(response);
                        })
                    }
                })
            }
        }
    }
    return (
        <div key={index} className="item product-layout product-grid">
            <div className="product-thumb transition product-item-container gift-boder-right">
                <div className="left-block">
                    <div className="banners product-image-container  second_img ">
                        <div className="image img-gift">
                            <a href={item.linksp ? ('/' + item.linksp?.replace('/', '')):(null)}>
                                {
                                    item.is_thumbnail_gifts ? (
                                        <>
                                            <Img key={item.thumbnail + index} imgTitle={item.name} url={item.thumbnail.replace('/origin', '/thumb')} />
                                            {/* <div className="img-gift-nav">
                                                <div className="special-text">
                                                    <Img key={item.thumbnail} imgTitle={item.name} url={item.thumbnail.replace('/origin', '/thumb')} className="img-gift2 lazyloaded" style="" />
                                                    <span className="special-text__tooltip">Tặng</span>
                                                </div>
                                            </div> */}
                                        </>

                                    ) : (
                                        <>
                                            <Img key={item.thumbnail + index} imgTitle={item.name} url={item.thumbnail.replace('/origin', '/thumb')} className="" style="" />
                                            {/* <Img key={item.thumbnail} imgTitle={item.name} url={item.thumbnail.replace('/origin', '/thumb')} className="img-2 img-responsive" style="" /> */}
                                        </>
                                    )
                                }
                            </a>
                        </div>
                        <div className="button-group cartinfo--right">
                            <button className="btn-button addToCart" title="Add to Cart" type="button" ><i className="fa fa-shopping-cart" onClick={() => handleAddToCart(item, '/' + item.linksp?.replace('/', ''))}></i> <span>Add to Cart</span></button>
                            <button className="btn-button wishlist" type="button" title="Add to Wish List" ><img onClick={() => handleWishlist(item.sku, item.isFavorite)} className="img-like" src={wishlist || item.isFavorite ? ("/../images/web_app/ic_like_active.svg") : ("https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_like.png")} alt="icon"/><span>Add to Wish List</span></button>
                            <button className="btn-button compare" type="button" title="Chi tiết sản phẩm" onClick={() => handleRedirect('/' + item.linksp?.replace('/', ''))}>
                                <i className="fa fa-eye" id={item.linksp}></i><span>Chi tiết sản phẩm</span></button>
                        </div>
                        {
                        item.labelPromo ? (
                            <img src={item.labelPromo['imageWeb']['default']['url']} alt="icon-chinh-hang" className="position-absolute"
                            style={item.labelPromo['position']['bottom']?({
                                width:+item.labelPromo['imageWeb']['default']['sizeImage']['width'],
                                height:+item.labelPromo['imageWeb']['default']['sizeImage']['height'],
                                left:+ item.labelPromo['position']['left'],
                                bottom:+ (+item.labelPromo['position']['bottom']),
                                zIndex:1, position:"absolute"
                        }):({
                            width:+item.labelPromo['imageWeb']['default']['sizeImage']['width'],
                            height:+item.labelPromo['imageWeb']['default']['sizeImage']['height'],
                            left:+ item.labelPromo['position']['left'],
                            top:+ item.labelPromo['position']['top'],
                            zIndex:1, position:"absolute"
                    })
                                
                            }/>
                        ):(null)
                    }
                    </div>
                    {
                        +item.price['discount'] !== +item.price['raw'] ? (<SaleOff key={index}
                            percen={RoundFloor(100 - percen)} />) : (null)
                    }
                </div>
                <PropertiesProduct key={index} item={item} tag='Mua là có Quà' />
            </div>
        </div>
    )
}
const ItemHotDealLanding = ({ item, index }) => {
    // console.log(item);
    const percen = +item?.price.discount / item.price.raw * 100;
    const location = useLocation();
    const handleAddToCart = (item, uri) => {
        if (isAuth() === false) {
            //toast.error('Bạn cần đăng nhập trước khi mua hàng.');
            setTimeout(() => { window.location.href = '/dang-nhap.html' }, 3500);
        } else {
            if (item.sku.includes('C') === true || +item.typePromotion === 3) {
                window.localStorage.setItem('typepage', 'product');
                if(uri !== '/undefined'){
                    // navigate(uri);
                    window.location.href = uri;
                }
            } else {
                let params = {
                    items: [{
                        product: item.sku,
                        type: 'item',
                        action: 'add',
                        quantity: 1,
                        promo_code: item.promoCode?? "",
                        combo_code: item.combCode ?? '',
                        uudai: item.uuDai,
                        user_referral:  window.localStorage.getItem('userReferral'),
                        id_share:   window.localStorage.getItem('idShare')
                    }]
                }
                try {
                    actionCart(params, window.localStorage.getItem('key')).then((response) => {
                        if(+response.status === 200 && response.message?.length > 0){
                        localStorage.removeItem("itemsCart");
                        localStorage.setItem('itemsCart', JSON.stringify(response['message']));
                        window.localStorage.setItem('reloadCart', true);
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({ ecommerce: null });
                        window.dataLayer.push({
                                'event': 'add_to_cart',
                                'ecommerce': {
                                'currency': "VND",
                                'value': +item.price?.import,
                                    'items': [
                                    {
                                        item_id: item.sku,
                                        item_name: item.name,
                                        price: +item.price?.import
                                    }
                                    ]
                                }
                            });
                        try{
                                pushtracking(window.localStorage.getItem('sessionId')??null,
                                window.localStorage.getItem('_id')??null,
                                window.localStorage.getItem('phone')??null ,
                                location.pathname, "Thêm sản phẩm vào giỏ hàng", 0,0,'index','inWeb',[item.sku],'Website PC').then((response)=>{
                                    console.log('send tracking');
                                });
                            }catch(e){console.log(e)}
                        toast.success('Thêm vào giỏ hàng thành công.');
                        }
                    });
                } catch (err) {
                    console.log(err);
                }
            }
        }
    }
    const handleRedirect = (uri) => {
        window.localStorage.setItem('typepage', 'product');
        if(uri !== '/undefined'){
            navigate(uri);
        }
    }
    const [wishlist, setWishlist] = useState(false);
    const handleWishlist = (sku, isFavorite) => {
        if (window.localStorage.getItem('key')) {
            setWishlist(!wishlist);
            checkWWishlist(window.localStorage.getItem('_id'), window.localStorage.getItem('_id'), sku).then((response) => {
                console.log(response);
            })

            if (isFavorite) {
                deleteWishlist(window.localStorage.getItem('_id'), window.localStorage.getItem('_id'), sku).then((response) => {
                    console.log(response);
                })
            } else {
                let param = {
                    "code": window.localStorage.getItem('_id'),
                    "user_id": window.localStorage.getItem('_id'),
                    "name": "danh-sach-yeu-thich",
                    "source": "cusapp",
                    "type": "",
                };
                createWishlist(param).then((response) => {
                    if (+response.status === 200) {
                        let data = {
                            "wishlist_id": window.localStorage.getItem('_id'),
                            "user_id": window.localStorage.getItem('_id'),
                            "product_id": sku,
                        };
                        addProductToWishlist(data).then((response) => {
                            console.log(response);
                        })
                    }
                })
            }
        }
    }
    return (
        <div key={index} className="item product-layout product-grid">
            <div className="product-thumb transition product-item-container hotdeal-boder-right">
                <div className="left-block">
                    <div className="product-image-container  second_img">
                        <div className="image">
                            <a onClick={() => handleRedirect('/' + item.linksp?.replace('/', ''))} href={'/' + item.linksp?.replace('/', '')}>
                                <Img key={item.thumbnail + index} imgTitle={item.name} url={item.thumbnail} className="" style="" />
                                {/* <Img key={item.thumbnail} imgTitle={item.name} url={item.thumbnail} className="img-2 img-responsive" style="" /> */}
                            </a>
                        </div>
                        <div className="button-group cartinfo--right">
                            <button className="btn-button addToCart" title="Add to Cart" type="button" onClick={() => handleAddToCart(item, '/' + item.linksp?.replace('/', ''))}><i className="fa fa-shopping-cart"></i> <span>Add to Cart</span></button>
                            <button className="btn-button wishlist" type="button" title="Add to Wish List" ><img onClick={() => handleWishlist(item.sku, item.isFavorite)} className="img-like" src={wishlist || item.isFavorite ? ("/../images/web_app/ic_like_active.svg") : ("https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_like.png")} alt="icon"/><span>Add to Wish List</span></button>
                            <button className="btn-button compare" type="button" title="Chi tiết sản phẩm"
                                onClick={() => handleRedirect('/' + item.linksp?.replace('/', ''))}
                            ><i className="fa fa-eye"></i><span>Chi tiết sản phẩm</span></button>
                        </div>

                        {
                        item.labelPromo ? (
                            <img src={item.labelPromo['imageWeb']['default']['url']} alt="icon-chinh-hang" className="position-absolute"
                            style={item.labelPromo['position']['bottom']?({
                                width:+item.labelPromo['imageWeb']['default']['sizeImage']['width'],
                                height:+item.labelPromo['imageWeb']['default']['sizeImage']['height'],
                                left:+ item.labelPromo['position']['left'],
                                bottom:+ (+item.labelPromo['position']['bottom']),
                                zIndex:1, position:"absolute"
                        }):({
                            width:+item.labelPromo['imageWeb']['default']['sizeImage']['width'],
                            height:+item.labelPromo['imageWeb']['default']['sizeImage']['height'],
                            left:+ item.labelPromo['position']['left'],
                            top:+ item.labelPromo['position']['top'],
                            zIndex:1, position:"absolute"
                    })
                                
                            }/>
                        ):(null)
                    }
                    </div>
                    {
                        +item.price['discount'] !== +item.price['raw'] ? (<SaleOff key={index}
                            percen={RoundFloor(100 - percen)} />) : (null)
                    }

                </div>
                <PropertiesHotdeal key={index} item={item} tag="Hotdeal" />
            </div>
        </div>
    )
}
const ItemDefaultLanding = ({ item, index, isShowAddToCart, isShowCategoryName }) => {
    
    console.log(item);
    if(item.typePromotion &&  +item.typePromotion  !== 1 && item.parent){
        item.linksp = item.parent.linksp;
    }
    const location = useLocation();
    const handleAddToCart = (item, uri) => {
        if (isAuth() === false) {
            //toast.error('Bạn cần đăng nhập trước khi mua hàng.');
            setTimeout(() => { window.location.href = '/dang-nhap.html' }, 3500);
        } else {
            if (item.sku.includes('C') === true || +item.typePromotion === 3) {
                window.localStorage.setItem('typepage', 'product');
                if(uri !== '/undefined'){
                    // navigate(uri);
                    window.location.href = uri;
                }
            } else {
                let params = {
                    items: [{
                        product: item.sku,
                        type: 'item',
                        action: 'add',
                        quantity: 1,
                        promo_code: item.promoCode?? "",
                        combo_code: item.combCode ?? '',
                        uudai: item.uuDai,
                        user_referral:  window.localStorage.getItem('userReferral'),
                        id_share:   window.localStorage.getItem('idShare')
                    }]
                }
                try {
                    actionCart(params, window.localStorage.getItem('key')).then((response) => {
                        if(+response.status === 200 && response.message?.length > 0){
                        localStorage.removeItem("itemsCart");
                        localStorage.setItem('itemsCart', JSON.stringify(response['message']));
                        window.localStorage.setItem('reloadCart', true);
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({ ecommerce: null });
                        window.dataLayer.push({
                                'event': 'add_to_cart',
                                'ecommerce': {
                                'currency': "VND",
                                'value': +item.price?.import,
                                    'items': [
                                    {
                                        item_id: item.sku,
                                        item_name: item.name,
                                        price: +item.price?.import
                                    }
                                    ]
                                }
                            });
                        try{
                                pushtracking(window.localStorage.getItem('sessionId')??null,
                                window.localStorage.getItem('_id')??null,
                                window.localStorage.getItem('phone')??null ,
                                location.pathname, "Thêm sản phẩm vào giỏ hàng", 0,0,'index','inWeb',[item.sku],'Website PC').then((response)=>{
                                    console.log('send tracking');
                                });
                            }catch(e){console.log(e)}
                        toast.success('Thêm vào giỏ hàng thành công.');
                        }
                    });
                } catch (err) {
                    console.log(err);
                }
            }
        }
    }
    const handleRedirect = (uri) => {
        window.localStorage.setItem('typepage', 'product');
        if(uri !== '/undefined'){
            navigate(uri);
        }
    }
    const [wishlist, setWishlist] = useState(false);
    const handleWishlist = (sku, isFavorite) => {
        if (window.localStorage.getItem('key')) {
            setWishlist(!wishlist);
            checkWWishlist(window.localStorage.getItem('_id'), window.localStorage.getItem('_id'), sku).then((response) => {
                console.log(response);
            })

            if (isFavorite) {
                deleteWishlist(window.localStorage.getItem('_id'), window.localStorage.getItem('_id'), sku).then((response) => {
                    console.log(response);
                })
            } else {
                let param = {
                    "code": window.localStorage.getItem('_id'),
                    "user_id": window.localStorage.getItem('_id'),
                    "name": "danh-sach-yeu-thich",
                    "source": "cusapp",
                    "type": "",
                };
                createWishlist(param).then((response) => {
                    if (+response.status === 200) {
                        let data = {
                            "wishlist_id": window.localStorage.getItem('_id'),
                            "user_id": window.localStorage.getItem('_id'),
                            "product_id": sku,
                        };
                        addProductToWishlist(data).then((response) => {
                            console.log(response);
                        })
                    }
                })
            }
        }
    }
    return (
        <div key={index} className="ltabs-item " style={{ opacity: 1 }}>
            <div className="item-inner product-layout transition product-grid">
                <div className="product-item-container myproduct product-thumb">
                    <div className="banners left-block">
                        <div className="product-image-container  second_img">
                        <div class="image">
                            <a href={'/' + item.linksp?.replace('/', '')} onClick={() => handleRedirect('/' + item.linksp?.replace('/', ''))}>
                                <Img key={item.thumbnail + index} data-sizes="auto" imgTitle={item.name} url={item.thumbnail.replace('/origin', '/thumb')} className="lazyload" style="" />
                            </a>
                        </div>
                        </div>
                        <div className="button-group cartinfo--right">
                            <button className="btn-button addToCart" title="Add to Cart" type="button" ><i className="fa fa-shopping-cart" onClick={() => handleAddToCart(item, '/' + item.linksp.replace('/', ''))}></i> <span>Add to Cart</span></button>
                            <button className="btn-button wishlist" type="button" title="Add to Wish List" ><img onClick={() => handleWishlist(item.sku, item.isFavorite)} className="img-like" src={wishlist || item.isFavorite ? ("/../images/web_app/ic_like_active.svg") : ("https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_like.png")} alt="icon"/><span>Add to Wish List</span></button>
                            <button className="btn-button compare" type="button" title="Chi tiết sản phẩm" id={item.linksp} onClick={() => handleRedirect('/' + item.linksp.replace('/', ''))} ><i className="fa fa-eye"></i><span>Chi tiết sản phẩm</span></button>
                        </div>
                        <div className="box-label">
                        </div>

                        {
                        item.labelPromo ? (
                            <img src={item.labelPromo['imageWeb']['default']['url']} alt="icon-chinh-hang" className="position-absolute"
                            style={item.labelPromo['position']['bottom']?({
                                width:+item.labelPromo['imageWeb']['default']['sizeImage']['width'],
                                height:+item.labelPromo['imageWeb']['default']['sizeImage']['height'],
                                left:+ item.labelPromo['position']['left'],
                                bottom:+ (+item.labelPromo['position']['bottom']),
                                zIndex:1, position:"absolute"
                        }):({
                            width:+item.labelPromo['imageWeb']['default']['sizeImage']['width'],
                            height:+item.labelPromo['imageWeb']['default']['sizeImage']['height'],
                            left:+ item.labelPromo['position']['left'],
                            top:+ item.labelPromo['position']['top'],
                            zIndex:1, position:"absolute"
                    })
                                
                            }/>
                        ):(null)
                    }
                    </div>
                    {
                        isShowCategoryName === true ? (
                            <div className="category-name">
                                {window.localStorage.getItem('nameCategory')}
                            </div>
                        ) : (null)
                    }
                    <PropertiesProduct key={index} item={item} />
                    {
                        isShowAddToCart === true ? (
                            <div className="row add-to-cart mgx-0 pdb-10"><div className="col-md-2 i-cart"><i className="fa fa-cart-plus" onClick={()=>handleAddToCart(item, '/'+item.linksp.replace('/',''))}></i></div> <span>Thêm vào giỏ</span></div>
                        ):(null)
                    }
                </div>
            </div>
        </div>
    )
}
const ItemDefaultLandingSlide = ({ item, index, isShowAddToCart, isShowCategoryName }) => {
    if(item.typePromotion &&  +item.typePromotion  !== 1 && item.parent){
        item.linksp = item.parent.linksp;
    }
    const location = useLocation();
    const handleAddToCart = (item, uri) => {
        if (isAuth() === false) {
            //toast.error('Bạn cần đăng nhập trước khi mua hàng.');
            setTimeout(() => { window.location.href = '/dang-nhap.html' }, 3500);
        } else {
            if (item.sku.includes('C') === true || +item.typePromotion === 3) {
                window.localStorage.setItem('typepage', 'product');
                if(uri !== '/undefined'){
                    // navigate(uri);
                    window.location.href = uri;
                }
            } else {
                let params = {
                    items: [{
                        product: item.sku,
                        type: 'item',
                        action: 'add',
                        quantity: 1,
                        promo_code: item.promoCode?? "",
                        combo_code: item.combCode ?? '',
                        uudai: item.uuDai,
                        user_referral:  window.localStorage.getItem('userReferral'),
                        id_share:   window.localStorage.getItem('idShare')
                    }]
                }
                try {
                    actionCart(params, window.localStorage.getItem('key')).then((response) => {
                        if(+response.status === 200 && response.message?.length > 0){
                        localStorage.removeItem("itemsCart");
                        localStorage.setItem('itemsCart', JSON.stringify(response['message']));
                        window.localStorage.setItem('reloadCart', true);
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({ ecommerce: null });
                        window.dataLayer.push({
                                'event': 'add_to_cart',
                                'ecommerce': {
                                'currency': "VND",
                                'value': +item.price?.import,
                                    'items': [
                                    {
                                        item_id: item.sku,
                                        item_name: item.name,
                                        price: +item.price?.import
                                    }
                                    ]
                                }
                            });
                        try{
                                pushtracking(window.localStorage.getItem('sessionId')??null,
                                window.localStorage.getItem('_id')??null,
                                window.localStorage.getItem('phone')??null ,
                                location.pathname, "Thêm sản phẩm vào giỏ hàng", 0,0,'index','inWeb',[item.sku],'Website PC').then((response)=>{
                                    console.log('send tracking');
                                });
                            }catch(e){console.log(e)}
                        toast.success('Thêm vào giỏ hàng thành công.');
                        }
                    });
                } catch (err) {
                    console.log(err);
                }
            }
        }
    }
    const handleRedirect = (uri) => {
        window.localStorage.setItem('typepage', 'product');
        if(uri !== '/undefined'){
            navigate(uri);
        }
    }
    const [wishlist, setWishlist] = useState(false);
    const handleWishlist = (sku, isFavorite) => {
        if (window.localStorage.getItem('key')) {
            setWishlist(!wishlist);
            checkWWishlist(window.localStorage.getItem('_id'), window.localStorage.getItem('_id'), sku).then((response) => {
                console.log(response);
            })

            if (isFavorite) {
                deleteWishlist(window.localStorage.getItem('_id'), window.localStorage.getItem('_id'), sku).then((response) => {
                    console.log(response);
                })
            } else {
                let param = {
                    "code": window.localStorage.getItem('_id'),
                    "user_id": window.localStorage.getItem('_id'),
                    "name": "danh-sach-yeu-thich",
                    "source": "cusapp",
                    "type": "",
                };
                createWishlist(param).then((response) => {
                    if (+response.status === 200) {
                        let data = {
                            "wishlist_id": window.localStorage.getItem('_id'),
                            "user_id": window.localStorage.getItem('_id'),
                            "product_id": sku,
                        };
                        addProductToWishlist(data).then((response) => {
                            console.log(response);
                        })
                    }
                })
            }
        }
    }
    return (
        <div key={index} className="ltabs-item-slide pdr-5" style={{ opacity: 1 }}>
            <div className="item-inner product-layout transition product-grid">
                <div className="product-item-container myproduct product-thumb">
                    <div className="banners left-block">
                        <div className="product-image-container  second_img">
                            <div class="image">
                                <a href={'/' + item.linksp?.replace('/', '')} onClick={() => handleRedirect('/' + item.linksp?.replace('/', ''))}>
                                    <Img key={item.thumbnail + index} data-sizes="auto" imgTitle={item.name} url={item.thumbnail.replace('/origin', '/thumb')} className="lazyload" style="" />
                                </a>
                            </div>
                        </div>
                        <div className="button-group cartinfo--right">
                            <button className="btn-button addToCart" title="Add to Cart" type="button" ><i className="fa fa-shopping-cart" onClick={() => handleAddToCart(item, '/' + item.linksp.replace('/', ''))}></i> <span>Add to Cart</span></button>
                            <button className="btn-button wishlist" type="button" title="Add to Wish List" ><img onClick={() => handleWishlist(item.sku, item.isFavorite)} className="img-like" src={wishlist || item.isFavorite ? ("/../images/web_app/ic_like_active.svg") : ("https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_like.png")} alt="icon"/><span>Add to Wish List</span></button>
                            <button className="btn-button compare" type="button" title="Chi tiết sản phẩm" id={item.linksp} onClick={() => handleRedirect('/' + item.linksp.replace('/', ''))} ><i className="fa fa-eye"></i><span>Chi tiết sản phẩm</span></button>
                        </div>
                        <div className="box-label">
                        </div>
                        {
                        item.labelPromo ? (
                            <img src={item.labelPromo['imageWeb']['default']['url']} alt="icon-chinh-hang" className="position-absolute"
                            style={item.labelPromo['position']['bottom']?({
                                width:+item.labelPromo['imageWeb']['default']['sizeImage']['width'],
                                height:+item.labelPromo['imageWeb']['default']['sizeImage']['height'],
                                left:+ item.labelPromo['position']['left'],
                                bottom:+ (+item.labelPromo['position']['bottom']),
                                zIndex:1, position:"absolute"
                        }):({
                            width:+item.labelPromo['imageWeb']['default']['sizeImage']['width'],
                            height:+item.labelPromo['imageWeb']['default']['sizeImage']['height'],
                            left:+ item.labelPromo['position']['left'],
                            top:+ item.labelPromo['position']['top'],
                            zIndex:1, position:"absolute"
                    })
                                
                            }/>
                        ):(null)
                    }
                    </div>
                    {
                        isShowCategoryName === true ? (
                            <div className="category-name">
                                {window.localStorage.getItem('nameCategory')}
                            </div>
                        ) : (null)
                    }
                    <PropertiesProduct key={index} item={item} />
                    {
                        isShowAddToCart === true ? (
                            <div className="row add-to-cart mgx-0 pdb-10"><div className="col-md-2 i-cart"><i className="fa fa-cart-plus" onClick={()=>handleAddToCart(item, '/'+item.linksp.replace('/',''))}></i></div> <span>Thêm vào giỏ</span></div>
                        ):(null)
                    }
                </div>
            </div>
        </div>
    )
}
const ItemAddGiftLanding = ({ item, index }) => {
    if(item.typePromotion &&  +item.typePromotion  !== 1 && item.parent){
        item.linksp = item.parent.linksp;
    }
    const percen = +item?.price['discount'] / item.price['raw'] * 100;
    const location = useLocation();
    const handleAddToCart = (item, uri) => {
        if (isAuth() === false) {
            //toast.error('Bạn cần đăng nhập trước khi mua hàng.');
            setTimeout(() => { window.location.href = '/dang-nhap.html' }, 3500);
        } else {
            if (item.sku.includes('C') === true || +item.typePromotion === 3) {
                window.localStorage.setItem('typepage', 'product');
                if(uri !== '/undefined'){
                    // navigate(uri);
                    window.location.href = uri;
                }
            } else {
                let params = {
                    items: [{
                        product: item.sku,
                        type: 'item',
                        action: 'add',
                        quantity: 1,
                        promo_code: item.promoCode?? "",
                        combo_code: item.combCode ?? '',
                        uudai: item.uuDai,
                        user_referral:  window.localStorage.getItem('userReferral'),
                        id_share:   window.localStorage.getItem('idShare')
                    }]
                }
                try {
                    actionCart(params, window.localStorage.getItem('key')).then((response) => {
                        if(+response.status === 200 && response.message?.length > 0){
                        localStorage.removeItem("itemsCart");
                        localStorage.setItem('itemsCart', JSON.stringify(response['message']));
                        window.localStorage.setItem('reloadCart', true);
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({ ecommerce: null });
                        window.dataLayer.push({
                                'event': 'add_to_cart',
                                'ecommerce': {
                                'currency': "VND",
                                'value': +item.price?.import,
                                    'items': [
                                    {
                                        item_id: item.sku,
                                        item_name: item.name,
                                        price: +item.price?.import
                                    }
                                    ]
                                }
                            });
                        try{
                                pushtracking(window.localStorage.getItem('sessionId')??null,
                                window.localStorage.getItem('_id')??null,
                                window.localStorage.getItem('phone')??null ,
                                location.pathname, "Thêm sản phẩm vào giỏ hàng", 0,0,'index','inWeb',[item.sku],'Website PC').then((response)=>{
                                    console.log('send tracking');
                                });
                            }catch(e){console.log(e)}
                        toast.success('Thêm vào giỏ hàng thành công.');
                        }
                    });
                } catch (err) {
                    console.log(err);
                }
            }
        }
    }
    const handleRedirect = (uri) => {
        window.localStorage.setItem('typepage', 'product');
        if(uri !== '/undefined'){
            navigate(uri);
        }
    }
    const [wishlist, setWishlist] = useState(false);
    const handleWishlist = (sku, isFavorite) => {
        if (window.localStorage.getItem('key')) {
            setWishlist(!wishlist);
            checkWWishlist(window.localStorage.getItem('_id'), window.localStorage.getItem('_id'), sku).then((response) => {
                console.log(response);
            })

            if (isFavorite) {
                deleteWishlist(window.localStorage.getItem('_id'), window.localStorage.getItem('_id'), sku).then((response) => {
                    console.log(response);
                })
            } else {
                let param = {
                    "code": window.localStorage.getItem('_id'),
                    "user_id": window.localStorage.getItem('_id'),
                    "name": "danh-sach-yeu-thich",
                    "source": "cusapp",
                    "type": "",
                };
                createWishlist(param).then((response) => {
                    if (+response.status === 200) {
                        let data = {
                            "wishlist_id": window.localStorage.getItem('_id'),
                            "user_id": window.localStorage.getItem('_id'),
                            "product_id": sku,
                        };
                        addProductToWishlist(data).then((response) => {
                            console.log(response);
                        })
                    }
                })
            }
        }
    }
    return (
        <div key={index} className="item product-layout product-grid pdr-5 mgt-10">
            <div className="product-thumb transition product-item-container gift-boder-right">
                <div className="left-block">
                    <div className="banners product-image-container  second_img ">
                        <div className="image img-gift">
                            <a href={'/' + item.linksp?.replace('/', '')} onClick={() => handleRedirect('/' + item.linksp?.replace('/', ''))}>
                                {
                                    item.thumbnail_gifts && item.thumbnail_gifts.length > 0 ? (
                                        <>
                                            <Img key={item.thumbnail + index} imgTitle={item.name} url={item.thumbnail.replace('/origin', '/thumb')}/>
                                            {/* <Img key={item.thumbnail+index} imgTitle={item.name} url={item.thumbnail} className="img-gift1 lazyloaded" style=""/>  */}
                                            {/* <div className="img-gift-nav"> */}
                                                {/* <div className="special-text">
                                    <Carousel key="gift"
                                        responsive={ResponsiveSliderTop}
                                        showDots={true}
                                        fade={true}
                                        // autoPlay={true}
                                        // autoPlaySpeed={2000}
                                        >
                                            {
                                                item.thumbnail_gifts.map((gift_img, i)=>{
                                                    return <div key={i}> 
                                                            <Img key={gift_img} imgTitle={item.name} url={gift_img.replace('/origin','/thumb')} className="img-gift2 lazyloaded" style=""/>
                                                        </div>
                                                })
                                            }
                                           </Carousel>
                                           <span className="special-text__tooltip">Tặng</span>
                                           </div> */}
                                                {/* <div className="special-text">
                                                    <Img key={item.thumbnail_gifts[0]} imgTitle={item.name} url={item.thumbnail_gifts[0].replace('/origin', '/thumb')} className="img-gift2 lazyloaded" style="" />
                                                    <span className="special-text__tooltip">Tặng</span>
                                                </div>
                                            </div> */}
                                        </>

                                    ) : (
                                        <>
                                            <Img key={item.thumbnail + index} imgTitle={item.name} url={item.thumbnail.replace('/origin', '/thumb')} className="" style="" />
                                            {/* <Img key={item.thumbnail} imgTitle={item.name} url={item.thumbnail.replace('/origin', '/thumb')} className="img-2 img-responsive" style="" /> */}
                                        </>
                                    )
                                }
                            </a>
                        </div>
                        <div className="button-group cartinfo--right">
                            <button className="btn-button addToCart" title="Add to Cart" type="button" ><i className="fa fa-shopping-cart" onClick={() => handleAddToCart(item, '/' + item.linksp?.replace('/', ''))}></i> <span>Add to Cart</span></button>
                            <button className="btn-button wishlist" type="button" title="Add to Wish List" ><img onClick={() => handleWishlist(item.sku, item.isFavorite)} className="img-like" src={wishlist || item.isFavorite ? ("/../images/web_app/ic_like_active.svg") : ("https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_like.png")} alt="icon"/><span>Add to Wish List</span></button>
                            <button className="btn-button compare" type="button" title="Chi tiết sản phẩm" onClick={() => handleRedirect('/' + item.linksp?.replace('/', ''))}>
                                <i className="fa fa-eye" id={item.linksp}></i><span>Chi tiết sản phẩm</span></button>
                        </div>
                        {
                        item.labelPromo ? (
                            <img src={item.labelPromo['imageWeb']['default']['url']} alt="icon-chinh-hang" className="position-absolute"
                            style={item.labelPromo['position']['bottom']?({
                                width:+item.labelPromo['imageWeb']['default']['sizeImage']['width'],
                                height:+item.labelPromo['imageWeb']['default']['sizeImage']['height'],
                                left:+ item.labelPromo['position']['left'],
                                bottom:+ (+item.labelPromo['position']['bottom']),
                                zIndex:1, position:"absolute"
                        }):({
                            width:+item.labelPromo['imageWeb']['default']['sizeImage']['width'],
                            height:+item.labelPromo['imageWeb']['default']['sizeImage']['height'],
                            left:+ item.labelPromo['position']['left'],
                            top:+ item.labelPromo['position']['top'],
                            zIndex:1, position:"absolute"
                    })
                                
                            }/>
                        ):(null)
                    }
                    </div>
                    {
                        +item.price['discount'] !== +item.price['raw'] ? (<SaleOff key={index}
                            percen={RoundFloor(100 - percen)} />) : (null)
                    }
                </div>
                <PropertiesProduct key={index} item={item} tag='Mua là có Quà' />
            </div>
        </div>
    )
}
const ItemHotDealLandingSlider = ({ item, index }) => {
    const percen = +item?.price['discount'] / item.price['raw'] * 100;
    const location = useLocation();
    const handleAddToCart = (item, uri) => {
        if (isAuth() === false) {
            //toast.error('Bạn cần đăng nhập trước khi mua hàng.');
            setTimeout(() => { window.location.href = '/dang-nhap.html' }, 3500);
        } else {
            if (item.sku.includes('C') === true || +item.typePromotion === 3) {
                window.localStorage.setItem('typepage', 'product');
                if(uri !== '/undefined'){
                    // navigate(uri);
                    window.location.href = uri;
                }
            } else {
                let params = {
                    items: [{
                        product: item.sku,
                        type: 'item',
                        action: 'add',
                        quantity: 1,
                        promo_code: item.promoCode?? "",
                        combo_code: item.combCode ?? '',
                        uudai: item.uuDai,
                        user_referral:  window.localStorage.getItem('userReferral'),
                        id_share:   window.localStorage.getItem('idShare')
                    }]
                }
                try {
                    actionCart(params, window.localStorage.getItem('key')).then((response) => {
                        if(+response.status === 200 && response.message?.length > 0){
                        localStorage.removeItem("itemsCart");
                        localStorage.setItem('itemsCart', JSON.stringify(response['message']));
                        window.localStorage.setItem('reloadCart', true);
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({ ecommerce: null });
                        window.dataLayer.push({
                                'event': 'add_to_cart',
                                'ecommerce': {
                                'currency': "VND",
                                'value': +item.price?.import,
                                    'items': [
                                    {
                                        item_id: item.sku,
                                        item_name: item.name,
                                        price: +item.price?.import
                                    }
                                    ]
                                }
                            });
                        try{
                                pushtracking(window.localStorage.getItem('sessionId')??null,
                                window.localStorage.getItem('_id')??null,
                                window.localStorage.getItem('phone')??null ,
                                location.pathname, "Thêm sản phẩm vào giỏ hàng", 0,0,'index','inWeb',[item.sku],'Website PC').then((response)=>{
                                    console.log('send tracking');
                                });
                            }catch(e){console.log(e)}
                        toast.success('Thêm vào giỏ hàng thành công.');
                        }
                    });
                } catch (err) {
                    console.log(err);
                }
            }
        }
    }
    const handleRedirect = (uri) => {
        window.localStorage.setItem('typepage', 'product');
        if(uri !== '/undefined'){
            if(uri !== '/undefined'){
                navigate(uri);
            }
        }
    }
    const [wishlist, setWishlist] = useState(false);
    const handleWishlist = (sku, isFavorite) => {
        if (window.localStorage.getItem('key')) {
            setWishlist(!wishlist);
            checkWWishlist(window.localStorage.getItem('_id'), window.localStorage.getItem('_id'), sku).then((response) => {
                console.log(response);
            })

            if (isFavorite) {
                deleteWishlist(window.localStorage.getItem('_id'), window.localStorage.getItem('_id'), sku).then((response) => {
                    console.log(response);
                })
            } else {
                let param = {
                    "code": window.localStorage.getItem('_id'),
                    "user_id": window.localStorage.getItem('_id'),
                    "name": "danh-sach-yeu-thich",
                    "source": "cusapp",
                    "type": "",
                };
                createWishlist(param).then((response) => {
                    if (+response.status === 200) {
                        let data = {
                            "wishlist_id": window.localStorage.getItem('_id'),
                            "user_id": window.localStorage.getItem('_id'),
                            "product_id": sku,
                        };
                        addProductToWishlist(data).then((response) => {
                            console.log(response);
                        })
                    }
                })
            }
        }
    }
    return (
        <div key={index} className="item product-layout product-grid pdr-5">
            <div className="product-thumb transition product-item-container hotdeal-boder-right">
                <div className="left-block">
                    <div className="product-image-container  second_img">
                        <div className="image">
                            <a onClick={() => handleRedirect('/' + item.linksp?.replace('/', ''))} href={'/' + item.linksp?.replace('/', '')}>
                                <Img key={item.thumbnail + index} imgTitle={item.name} url={item.thumbnail} className="" style="" />
                                {/* <Img key={item.thumbnail} imgTitle={item.name} url={item.thumbnail} className="img-2 img-responsive" style="" /> */}
                            </a>
                        </div>
                        <div className="button-group cartinfo--right">
                            <button className="btn-button addToCart" title="Add to Cart" type="button" onClick={() => handleAddToCart(item, '/' + item.linksp?.replace('/', ''))}><i className="fa fa-shopping-cart"></i> <span>Add to Cart</span></button>
                            <button className="btn-button wishlist" type="button" title="Add to Wish List" ><img onClick={() => handleWishlist(item.sku, item.isFavorite)} className="img-like" src={wishlist || item.isFavorite ? ("/../images/web_app/ic_like_active.svg") : ("https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_like.png")} alt="icon"/><span>Add to Wish List</span></button>
                            <button className="btn-button compare" type="button" title="Chi tiết sản phẩm"
                                onClick={() => handleRedirect('/' + item.linksp?.replace('/', ''))}
                            ><i className="fa fa-eye"></i><span>Chi tiết sản phẩm</span></button>
                        </div>
                        {
                        item.labelPromo ? (
                            <img src={item.labelPromo['imageWeb']['default']['url']} alt="icon-chinh-hang" className="position-absolute"
                            style={item.labelPromo['position']['bottom']?({
                                width:+item.labelPromo['imageWeb']['default']['sizeImage']['width'],
                                height:+item.labelPromo['imageWeb']['default']['sizeImage']['height'],
                                left:+ item.labelPromo['position']['left'],
                                bottom:+ (+item.labelPromo['position']['bottom']),
                                zIndex:1, position:"absolute"
                        }):({
                            width:+item.labelPromo['imageWeb']['default']['sizeImage']['width'],
                            height:+item.labelPromo['imageWeb']['default']['sizeImage']['height'],
                            left:+ item.labelPromo['position']['left'],
                            top:+ item.labelPromo['position']['top'],
                            zIndex:1, position:"absolute"
                    })
                                
                            }/>
                        ):(null)
                    }
                    </div>
                    {
                        +item.price['discount'] !== +item.price['raw'] ? (<SaleOff key={index}
                            percen={RoundFloor(100 - percen)} />) : (null)
                    }

                </div>
                <PropertiesHotdeal key={index} item={item} tag="Hotdeal" />
            </div>
        </div>
    )
}
export { ItemHotDeal, Item, ItemAddGift, ItemDefault, Upsell, ItemLanding, ItemHotDealLanding, ItemDefaultLanding, ItemDefaultLandingSlide, ItemAddGiftLanding, ItemHotDealLandingSlider };